import positionProperties from '../../../common/constants/position-properties';
import { ASPECT_RATIO_CSS_PROPERTY, WIDTH_CSS_PROPERTY } from '../constants/media-container';

const PROPERTIES_TO_CLEAR = [
  ASPECT_RATIO_CSS_PROPERTY,
  WIDTH_CSS_PROPERTY,
  positionProperties.X,
  positionProperties.Y,
];

const clearResizedElementsInlineStyles = (elements) => {
  // Defer inline-style cleanup to the next paint frame. Callers that change width via
  // `w-[…]` or a composite item's position via `position-[…]` must wait for
  // design-automation `AUTOMATION_COMPLETED` (atomic CSS regen finishes in that path)
  // before invoking this — otherwise the element falls back to its template default
  // and the highlighter jumps.
  requestAnimationFrame(() => {
    elements.forEach((resizedElement) => {
      PROPERTIES_TO_CLEAR.forEach((property) => {
        resizedElement.style.removeProperty(property);
      });
    });
  });
};

export default clearResizedElementsInlineStyles;
